<template>
	<div id="app">
		<VueShowdown :markdown="content" flavor="github" :options="{ emoji: true }" />
	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		name: 'app',
		data() {
			return {
				content: ""
			}
		},
		mounted: function() {
			var that = this;
			var theRequest = that.GetRequest();
			axios.get("http://gateway.dysyds.com/mall-shop/api/cms/getPlatformInfo?categoryId=" +
					theRequest.categoryId)
				.then(function(response) {
          console.log(response)
					that.content = response.data.data[0].content;
				})
				.catch(function(error) {
					console.log(error)
				})
		},
		methods: {
			GetRequest() {
				var url = location.search; //获取url中"?"符后的字串
				var theRequest = new Object();
				if (url.indexOf("?") != -1) {
					var str = url.substr(1);
					var strs = str.split("&");
					for (var i = 0; i < strs.length; i++) {
						theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
					}
				}
				return theRequest;
			}
		}
	}
</script>
